import { StepLabel, styled } from '@mui/material';

const StyledStepLabel = styled(StepLabel)({});

export { StyledStepLabel };
